import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';

import { fetchToken } from './utils';

interface UseToken {
  token: string;
  hasError: boolean;
  errorCode: string;
}

export const useToken = (): UseToken => {
  const request = useRequest();
  const [token, setToken] = useState('');
  const [hasError, setError] = useState(false);
  const [errorCode, setErrorCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [retryToken, setRetryToken] = useState(false);

  useEffect(() => {
    const initiateFetchToken = (retryCount = 0) => {
      setIsLoading(true);
      setRetryToken(false);
      fetchToken(request, retryCount).subscribe(
        ({ body }) => {
          setError(false);
          setToken(body.token);
          setIsLoading(false);
        },
        (error) => {
          setErrorCode(error?.body?.globalErrors?.[0]?.code);
          setError(true);
          setIsLoading(false);
          if (!hasError && error.response?.status >= 500) {
            setRetryToken(true);
          }
        }
      );
    };

    if (!token && !isLoading && !hasError) {
      initiateFetchToken();
    } else if (!token && !isLoading && hasError && retryToken) {
      initiateFetchToken(1);
    }
  }, [request, setError, setToken, isLoading, token, hasError, errorCode, retryToken]);

  return { token, hasError, errorCode };
};
